"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _css = require("@emotion/css");
var _react = require("react");
var useStyles = function useStyles(props) {
  var _props$fillColor = props.fillColor,
    fillColor = _props$fillColor === void 0 ? 'currentColor' : _props$fillColor;
  var ccIconStyle = (0, _react.useMemo)(function () {
    var ccIcon = (0, _css.css)({
      stroke: 'none',
      fill: fillColor
    });
    return ccIcon;
  }, [fillColor]);
  return {
    'cc-Icon': ccIconStyle
  };
};
exports.useStyles = useStyles;